<template>
    <v-navigation-drawer
        class="app--drawer"
        :mini-variant.sync="mini"
        app
        v-model="drawerVisivility"
        :width="drawWidth"
    >
        <v-toolbar dark color="primary darken-1">
            <img src="@/images/LogoMenu.png" height="36" alt="Todocolegios" />
            <v-toolbar-title class="ml-0 pl-3">
                <span class="hidden-sm-and-down">Todocolegios</span>
            </v-toolbar-title>
        </v-toolbar>
        <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
            <v-list dense expand class="mb-3">
                <template v-for="(item, i) in computedMenu">
                    <!--group with subitems-->
                    <v-list-group v-if="item.items" :key="item.name" :group="item.group" no-action="no-action">
                        <v-icon slot="prependIcon">{{ item.icon }}</v-icon>
                        <v-icon slot="appendIcon" style="font-weight: bold">fa-angle-down</v-icon>
                        <v-list-tile slot="activator" ripple="ripple">
                            <v-list-tile-content>
                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <template v-for="(subItem, i) in item.items">
                            <!--sub group-->
                            <v-list-group
                                v-if="subItem.items"
                                :key="subItem.name"
                                :group="subItem.group"
                                sub-group="sub-group"
                            >
                                <v-list-tile slot="activator" ripple="ripple">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile
                                    v-for="(grand, i) in subItem.children"
                                    :key="i"
                                    :to="genChildTarget(item, grand)"
                                    :href="grand.href"
                                    ripple="ripple"
                                >
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list-group>
                            <!--child item-->
                            <v-list-tile
                                v-else
                                :key="i"
                                :to="genChildTarget(item, subItem)"
                                :href="subItem.href"
                                :disabled="subItem.disabled"
                                :target="subItem.target"
                                ripple="ripple"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title
                                        ><span>{{ subItem.title }}</span></v-list-tile-title
                                    >
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </v-list-group>
                    <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
                    <v-divider v-else-if="item.divider" :key="i"></v-divider>
                    <!--top-level link-->
                    <v-list-tile
                        v-else
                        :to="!item.href ? { name: item.name } : null"
                        :href="item.href"
                        ripple="ripple"
                        :disabled="item.disabled"
                        :target="item.target"
                        rel="noopener"
                        :key="item.name"
                    >
                        <v-list-tile-action v-if="item.icon">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </vue-perfect-scrollbar>
    </v-navigation-drawer>
</template>
<script>
import menu from "@/api/menu"
import VuePerfectScrollbar from "vue-perfect-scrollbar"

export default {
    name: "AppDrawer",
    components: {
        VuePerfectScrollbar
    },
    props: {
        expanded: {
            type: Boolean,
            default: true
        },
        drawWidth: {
            type: [Number, String],
            default: "260"
        },
        showDrawer: Boolean
    },
    data() {
        return {
            mini: false,
            menus: menu,
            scrollSettings: {
                maxScrollbarLength: 160
            },

            drawerMark: false
        }
    },
    computed: {
        computedMenu() {
            let new_menu = []
            this.menus.forEach(entry => {
                if (entry.header) {
                    //entradas de header
                    new_menu.push(entry)
                }

                if (entry.roles === "*") {
                    //entradas publlicas
                    new_menu.push(entry)
                } else {
                    //entradas con roles
                    if (!entry.items) {
                        //entradas que no tienen subentradas
                        if (entry.roles && this.$store.getters.HAS_ROLE(entry.roles)) {
                            //entradas sin subitems
                            new_menu.push(entry)
                        }
                    } else {
                        //entradas que tienen subentradas
                        let new_entry = entry
                        let new_items = []

                        entry.items.forEach(el => {
                            if (this.$store.getters.HAS_ROLE(el.roles)) {
                                new_items.push(el)
                            }
                        })

                        if (new_items.length > 0) {
                            new_entry.items = new_items
                            new_menu.push(new_entry)
                        }
                    }
                }
            })
            return new_menu
        },

        drawerVisivility: {
            get: function() {
                return this.showDrawer
            },
            set: function() {
                return (this.drawerMark = !this.drawerMark)
            }
        }
    },
    created() {},

    methods: {
        genChildTarget(item, subItem) {
            if (subItem.href) return
            if (subItem.component) {
                return {
                    name: subItem.component
                }
            }
            return { name: `${item.group}/${subItem.name}` }
        }
    },

    watch: {
        drawerMark: function() {
            if (!this.drawerMark) {
                this.$emit("close-drawer")
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
.app--drawer
    overflow: hidden

    .drawer-menu--scroll
        height: calc(100vh - 48px)
        overflow: auto
</style>
